module.exports = __webpack_public_path__ + "static/winners-take-all-369309b845493067235fd1e348d6f0c3.jpg";